import ImageNotSupportedIcon from '@mui/icons-material/ImageNotSupported';

import { CardContent, CardMedia } from '@mui/material';
import { Ads } from 'api/ads';
import { Card, Title } from 'common';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';

import { useLanguage } from '../../../context/LanguageContext'

interface AdsCardProps {
    adsItem: Ads;
}

export const AdsCard = ({ adsItem }: AdsCardProps) => {
    const { language } = useLanguage();

    return (
        <Link to={`/ads/${adsItem.id}`} style={{ textDecoration: 'none' }}>
            <Card sx={{ maxWidth: 345, marginBottom: 2, border: '1px solid #af0000' }}>
                {adsItem.images && adsItem.images.length > 0 && adsItem.images[0] ? (
                    <CardMedia
                        component="img"
                        height="200"
                        sx={{ borderRadius: 1 }}
                        image={adsItem.images[0].photo}
                        alt={adsItem.title}
                        
                    />
                ) : (
                    <ImageNotSupportedIcon
                        sx={{
                            height: 200,
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '5rem'
                        }}
                    />
                )}
                <CardContent>
                    <Title
                        gutterBottom
                        variant="h5"
                        component="div"
                        sx={{
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            fontWeight: 600,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}
                    >
                        {adsItem[`title_${language}`]}
                    </Title>
                    <Title
                        gutterBottom
                        variant="body1"
                        color="text.secondary"
                        sx={{
                            display: '-webkit-box',
                            WebkitLineClamp: 4, // количество строк, для отображения
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}
                    >
                        {adsItem[`description_${language}`]}
                    </Title>
                    <Title variant="body2" color="text.primary">
                        {dayjs(adsItem.created_at).format('DD.MM.YYYY')}
                    </Title>
                </CardContent>
            </Card>
        </Link>
    );
};
